<!-- <div fxFlex fxLayoutAlign="end end">
        <img src="assets/icons/arrow.svg" style="width: 13px; height: 8px; align-self: center;"
          fxLayoutAlign="end center" />
      </div> -->
<!-- <span class="selectfor medium">Select For Checkout</span> -->
<!-- <span fxLayout="column" style="padding-top: 10px;" fxLayoutAlign="center center">
      <button mat-flat-button color="primary" (click)="onDone()" class="button-done"
        ngClass.xs="button-done xs">Done</button>
    </span> -->
<div class="content normal" ngClass.xs="content xs" ngClass.sm="content sm" ngClass.md="content md">
  <div fxLayout="column" *ngFor="let checkin of data" fxLayoutGap="10px">
    <span id="span-dash-left"></span>
    <div fxLayout="row" fxLayoutGap="15px">
      <mat-checkbox color="primary" *ngIf="checkin.groupMembers.length === 0 && !fromCheckin" fxFlexAlign="center" [checked]="checkin.isSelected"
        (change)="onSelectChange(checkin.checkInId,$event.checked)"></mat-checkbox>
      <mat-checkbox color="primary" *ngIf="checkin.groupMembers.length !== 0 && !fromCheckin" fxFlexAlign="center" [checked]="checkin.isSelected"
        (change)="onSelectGroupChange(checkin.groupId,$event.checked)"></mat-checkbox>
      <!-- <span fxFlex> -->
      <span fxLayout="column">
        <span class="title regular" *ngIf="checkin.groupMembers.length === 0"
          ngStyle.xs="font-size:14px">{{checkin.name}}</span>
        <span class="title regular" *ngIf="checkin.groupMembers.length !== 0"
          ngStyle.xs="font-size:14px">{{checkin.groupName}}</span>
        <span class="subtitle regular" *ngIf="checkin.extendedDuration === undefined && !fromCheckin">{{'for' | transloco}}
          {{checkin.checkInDate |date:'d MMMM'}}</span>
        <span class="subtitle regular" *ngIf="checkin.extendedDuration !== undefined && !fromCheckin">{{'for' | transloco}}
          {{checkin.extendedDuration.startDate| date:'d MMMM' }} -
          {{checkin.extendedDuration.endDate | date:'d MMMM'}}</span>
      </span>
      <div fxFlex *ngIf="checkin.groupMembers.length !== 0" style="cursor: pointer;" fxLayoutAlign="end end" (click)="openDetailDialog(checkin)">
        <img src="assets/icons/arrow.svg" style="width: 13px; height: 8px; align-self: center;cursor: pointer;"
          fxLayoutAlign="end center" />
      </div>
    </div>
    <span id="span-dash-left"></span>
  </div>
</div>
